'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('`', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/code-inline.js
// module id = 2303
// module chunks = 0